export const questionStringToArray: (questionString: string) => arrayQuestion[] = (
  questionString
) => {
  const questions = [];
  const questionRegex = /\d\.\s([\s\S]*?)\*\*/g;
  let match;

  while ((match = questionRegex.exec(questionString)) !== null) {
    questions.push(match[1].trim());
  }

  if (questions.length > 0) {
    return questions.map((item, index) => ({
      id: index,
      text: item,
      copied: false,
      selected: false,
      status: 'notSent'
    }));
  }

  return [
    {
      id: 0,
      text: questionString,
      copied: false,
      selected: false,
      status: 'notSent'
    }
  ];
};

export const formatQuestionArray: (questionArray: string[]) => arrayQuestion[] = (
  questionArray
) => {
  return questionArray.map((item, index) => ({
    id: index,
    text: item,
    copied: false,
    selected: false,
    status: 'notSent'
  }));
};

export interface arrayQuestion {
  id: number;
  text: string;
  copied: boolean;
  selected: boolean;
  status: 'notSent' | 'sent' | 'loading' | 'error' | 'deleting';
}
